export class CarouselCareer {
  constructor(Flickity) {
    this.gallery = document.querySelector('.careerVideoSlider');

    if (this.gallery) {
      this.initCarousel(Flickity);
      this.bindEvents();
    }
  }

  initCarousel(Flickity) {
    this.carousel = new Flickity(this.gallery, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
    });
  }

  bindEvents() {
    const playBtn = document.querySelectorAll('.playVideoBtn');
    const videos = document.querySelectorAll('.careerSlide iframe');
    const slide = document.querySelectorAll('.careerSlide');
    const currentIndex = document.querySelector('.sliderCounter__current');
    const slideLength = slide.length;
    const slideLengthElement = document.querySelector('.sliderCounter__length');

    slideLengthElement.innerHTML = slideLength;


    playBtn.forEach((element, index) => {
      element.addEventListener('click', () => {
        if (slide[index].classList.contains('is-selected')) {
          videos[index].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          slide[index].classList.add('active--video');
        }
      });
    });

    this.carousel.on('select', () => {
      if (parseInt(currentIndex.innerHTML, 10) !== (this.carousel.selectedIndex + 1)) {
        // if values have changed
        currentIndex.innerHTML = this.carousel.selectedIndex + 1;
        videos.forEach((element, index) => {
          videos[index].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          slide[index].classList.remove('active--video');
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/carousel-career.js